//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      showFixed: !this.$cookies.get('downShow') // 是否显示
    }
  },
  methods: {
    close () {
      this.showFixed = false
      this.$cookies.set('downShow', true, { path: '/', domain: this.$store.state.cookieHost, maxAge: 43200 })
    }
  }
}
